// @flow
import React, { Component, type ComponentType } from "react";

import Spinner from "@atlaskit/spinner";
import InfiniteScroll from "react-infinite-scroller";
import { getOriginal } from "../utils/image";

import { SpinnerContainer, Photos, Month, Spacer, Overlay, TitleText } from "./styled";

type Props = {|
    photos: ComponentType<any>,
    onFetchPhotos: Function,
    onShowPhotos: Function
|};

type State = {
    isLoading: boolean,
    maxRowsToDisplay: Number
};

class PhotosPageView extends Component<Props, State> {
    // We set the loading state at the beginning after which the state can only be set to
    // loaded through the spinner. This allows us to have a 'completed' animated for the spinner.
    constructor(props) {
        super(props);
        const { photos } = props;
        this.state = {
            isLoading: photos === null,
            maxRowsToDisplay: 5
        };
    }

    componentDidMount() {
        if (this.state.isLoading) {
            this.props.onFetchPhotos();
        }
    }

    render() {
        const { photos, onShowPhotos } = this.props;

        if (this.state.isLoading) {
            return (
                <SpinnerContainer>
                    <Spinner
                        size="medium"
                        isCompleting={this.props.photos != null}
                        onComplete={() => this.setState({ isLoading: false })}
                    />
                </SpinnerContainer>
            );
        }

        const displayedPhotos = [];
        for (let i = 0; i < photos.length && i < this.state.maxRowsToDisplay; i += 1) {
            const photoSummary = photos[i];
            displayedPhotos.push(
                <Month
                    key={`photo${photoSummary.id}`}
                    onClick={() => onShowPhotos(photoSummary)}
                    style={{
                        backgroundImage: `url(${getOriginal(photoSummary.url)})`
                    }}
                >
                    <Overlay>
                        <TitleText>{photoSummary.title}</TitleText>
                    </Overlay>
                </Month>
            );
        }

        return (
            <div>
                <Spacer />
                <Photos>
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={() =>
                            this.setState({
                                maxRowsToDisplay: this.state.maxRowsToDisplay + 5
                            })
                        }
                        hasMore={this.state.maxRowsToDisplay < photos.length}
                        loader={
                            <div className="loader" key={0}>
                                Loading ...
                            </div>
                        }
                    >
                        {displayedPhotos}
                    </InfiniteScroll>
                </Photos>
                <Spacer />
            </div>
        );
    }
}

export default PhotosPageView;



// WEBPACK FOOTER //
// ./src/photos-page-view/view.js